import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"firetable-pagination"},[_c('div',{staticClass:"current-page"},[_vm._v("Page "+_vm._s(_vm.page))]),_c(VBtn,{attrs:{"disabled":_vm.isLoading || _vm.page <= 1,"icon":""},on:{"click":function($event){return _vm.$emit('prev')}}},[_c(VIcon,[_vm._v("mdi-chevron-left")])],1),_c(VBtn,{attrs:{"disabled":_vm.isLoading || !_vm.hasMore,"icon":""},on:{"click":function($event){return _vm.$emit('next')}}},[_c(VIcon,[_vm._v("mdi-chevron-right")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }